import { DocumentLoadError } from './document-loader.js';
import { initLogger } from '../logger.js';
/**
 * A {@link DocumentLoader} over a caller-supplied map of documentId -> document. Browser
 * consumers mount their virtual filesystem (and the CALM meta-schemas they bundle) through
 * this loader; it is also convenient for tests.
 *
 * Documents whose `$id` is a string are registered as schemas on initialise, so schema lookups
 * behave exactly as they do with {@link FileSystemDocumentLoader} over a schema directory.
 *
 * Documents are returned by reference, not cloned, so a consumer reusing one `documents` map
 * across runs shares object identity between runs — unlike {@link FileSystemDocumentLoader},
 * which re-parses from disk on every load.
 */
export class InMemoryDocumentLoader {
    constructor(documents, debug = false) {
        this.documents = documents;
        this.logger = initLogger(debug, 'in-memory-document-loader');
    }
    async initialise(schemaDirectory) {
        for (const [key, document] of Object.entries(this.documents)) {
            const id = document['$id'];
            if (typeof id !== 'string') {
                this.logger.debug(`Skipping ${key}: no $id, not a schema.`);
                continue;
            }
            schemaDirectory.storeDocument(id, 'schema', document);
            this.logger.debug(`Registered schema ${id} from in-memory document ${key}.`);
        }
    }
    async loadMissingDocument(documentId, type) {
        if (Object.prototype.hasOwnProperty.call(this.documents, documentId)) {
            return this.documents[documentId];
        }
        const message = `Document with id [${documentId}] and type [${type}] is not present in the in-memory document store.`;
        this.logger.debug(message);
        throw new DocumentLoadError({ name: 'OPERATION_NOT_IMPLEMENTED', message });
    }
    resolvePath(_reference) {
        return undefined;
    }
}
//# sourceMappingURL=in-memory-document-loader.js.map